import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { closeEpic } from './_epics/close.epic';
import { openEpic } from './_epics/open.epic';
import { linkToggleEditWithLocationEpic } from './_epics/linkToggleEditWithLocation.epic';

export const detailsSidebarEpic = safeCombineEpics(
  closeEpic,
  openEpic,
  linkToggleEditWithLocationEpic,
);
